module.exports = __webpack_public_path__ + "static/media/zola-registry-logo-white-mobile.1ca00185.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-registry-logo-white-mobile.svg
// module id = 2405
// module chunks = 50